import React, { useState } from 'react';
import Hero from '../components/Team/Hero';
import Tabs from '../components/Team/Tabs';
import Overview from '../components/Team/Overview';
import Squad from '../components/Team/Squad';
import TeamNews from '../components/Team/TeamNews';
import { getTeamHeroInformation } from '../utils/team';
import { useTeam } from '../hooks/team';
import { useSquad } from '../hooks/squad';
import { useTeamNews } from '../hooks/news';

function SingleTeam() {
  const abbrv = window.pageData.id;
  const [contentToDisplay, setContentToDisplay] = useState('overview');
  const [team, teamLoading, teamError] = useTeam(abbrv);
  const [squad, squadLoading, squadError] = useSquad(abbrv);
  const [news, newsLoading, newsError] = useTeamNews(abbrv);

  const teamHeroInformation =
    team && !teamLoading ? getTeamHeroInformation(team) : null;

  if (teamLoading || teamError) return null;

  return (
    <>
      <Hero teamHeroInformation={teamHeroInformation} />
      <Tabs switchContent={setContentToDisplay} />
      <section className="site-container">
        <div className="row">
          <div className="col-12">
            <Overview
              abbrv={abbrv}
              team={team}
              show={contentToDisplay === 'overview'}
            />
            <Squad
              loading={squadLoading}
              squad={squad}
              team={team}
              error={squadError}
              show={contentToDisplay === 'squad'}
            />
            <TeamNews
              loading={newsLoading}
              abbrv={abbrv}
              news={news}
              error={newsError}
              show={contentToDisplay === 'news'}
            />
          </div>
        </div>
      </section>
    </>
  );
}

export default SingleTeam;
